<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/leaves">{{$t('leave_scheme')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('leave_scheme_create') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>

        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.Code.required">- សូមធ្វើការបញ្ជូលកូដ</div>
                        <div class="error" v-if="!$v.model.Description.required">- សូមធ្វើការបញ្ជូល{{$t('description')}}</div>
                    </div>
                    <form ref="form">
                        <div class="row">
                            <div class="col-sm-2">
                                <div class="form-group" :class="{'form-group-error': $v.model.Code.$error}">
                                    <label class="label-control blue">{{$t('code')}}</label>
                                    <div>
                                        <input type="text" class="form-control form-control-sm" v-model="model.Code"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.Description.$error }">
                                    <label class="label-control blue">{{$t('description')}}</label>
                                    <div>
                                        <input type="text" class="form-control form-control-sm" v-model="$v.model.Description.$model"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4">
                                <table class="table table-bordered table-sm no-bor">
                                    <thead>
                                        <tr>
                                            <th style="width: 30px;" class="text-center">
                                                <input type="checkbox" @click="allClick" />
                                            </th>
                                            <th>{{$t('code')}}</th>
                                            <th>{{$t('description')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="ret in leaves" :key="ret.Id">
                                            <td class="text-center">
                                                <input type="checkbox" v-model="ret.Checked" />
                                            </td>
                                            <td>{{ret.Code}}</td>
                                            <td>{{ret.Description}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        data: function () {
            return {
                model: {
                    Code: '',
                    Description: ''
                },
                leaves: [],
                actionLink: 'scheme/save'
            }
        },
        validations: {
            model: {
                Code: {required},
                Description: {required}
            }
        },
        async created() {
            const id = this.$route.params.id;
            await this.typeList();
            if(id !== undefined && id != null && id !== ''){
                this.findById(id);
            }
        },
        methods:{
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('scheme/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Json.Scheme;
                        let links = res.data.Json.Links;
                        this.leaves.forEach(el => {
                            if(links.includes(el.Id)) el.Checked = true;
                        });
                    }
                }).finally(function(){ loading.hide(); });
            },
            clickSaveHandler(){
                this.$v.$touch();
                if(!this.$v.$invalid){
                    var loading = this.$loading.show();
                    this.model.Date = this.date;
                    let req = {
                        LeaveScheme: this.model,
                        Links: []
                    };
                    this.leaves.forEach(ele => {
                        if(ele.Checked) req.Links.push({ LeaveTypeId: ele.Id });
                    });
                    this.$api().post(this.actionLink, req).then(res => {
                        if(this.$isValid(res)){
                            this.$router.push('/schemes');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            async typeList() {
                var res = await this.$api().post('leaves', { Limit: 0 });
                if (this.$isValid(res)) {
                    this.leaves = res.data.Json.Leaves;
                }
            },
            allClick(e){
                this.leaves.forEach(element => {
                    element.Checked = e.target.checked;
                });
            }
        }
    }
</script>